/*global
    jQuery, dataLayer
*/

(function ($) {
    //gtm event tracks
    'use strict';

    var $tracks = $('[data-track]'), //elements with data-track attribute

        defaults = {
            'event': 'eventTracker',
            'eventCat': 'Misc',
            'eventAct': 'Event',
            'eventLbl': 'Misc',
            'eventVal': 0
        },

        pushToDataLayer = function () {
            var $this = $(this),
                push = function () {
                    //populate googles dataLayer
                    dataLayer.push($.extend({}, defaults, $(this).data('track')));

                };

            $this.on('click', push);
        };
    //init
    $tracks.each(pushToDataLayer);

}(jQuery));

